// extracted by mini-css-extract-plugin
export default {"container":"AuthBySmsOtpInput_container__EK6xM","input":"AuthBySmsOtpInput_input__sMazr","invalid":"AuthBySmsOtpInput_invalid__VDKgG"};